import { useQuery } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';
import { useIsPreActiveCustomer } from '../../../../../../../hooks/useIsPreActiveCustomer';
import { useUser } from '../../../../../../../utils/UserContext';
import { CustomerWithDriverOnboarding } from '../../../../../../../types/apiTypes';
import { getDemoReportPack } from '../demoAccountingData';

export function useReportPack(reportPackId: string) {
  const { callProtectedApi } = useApi();
  const { userRecord } = useUser();
  const isPreActive = useIsPreActiveCustomer();
  const businessType = (userRecord as CustomerWithDriverOnboarding | null)
    ?.business_type;

  return useQuery({
    queryKey: ['accounting-report-pack', reportPackId],
    queryFn: async () => {
      const response = await callProtectedApi(
        `/accounting/report-packs/${reportPackId}`,
        'get'
      );
      return response?.data?.data;
    },
    // See useIncomeStatement — demo data for pre-active, no request fired, and
    // placeholder rather than initial so it never enters the cache. Demo packs
    // are always `ready`, and placeholder data isn't in `query.state.data`, so
    // the poll below stays off either way.
    enabled: !!reportPackId && !isPreActive,
    placeholderData: isPreActive
      ? () => getDemoReportPack(reportPackId, businessType)
      : undefined,
    refetchInterval: (query) => {
      const pack = query.state.data as { status: string } | undefined;
      if (pack?.status === 'generating') {
        return 3000;
      }
      return false;
    },
  });
}
